<div class="list-container" *ngIf="cmsContent$ | async as cmsContentConfig">
  <div class="position">{{leader.position}}</div>
  <div>{{leader.firstName}} {{leader.lastName[0]}}.</div>
  <div>{{leader.totalPoints}}{{cmsContentConfig['text_content']['games(profile)-points-label']}}</div>
</div>
